//* import styles
import { useContext } from "react";
import RegisterUser from "../../db/RegisterUser";
import { AuthContext } from "../../store/auth-context";
import styles from "./SignUpForm.module.css";
import SignUpForm1 from "./SignUpForm1";
import SignUpForm2 from "./SignUpForm2";
import SignUpForm3 from "./SignUpForm3";
import SignUpFormAction1 from "./SignUpFormAction1";
const SignUpFormGroup = (props) => {
  const authCtx = useContext(AuthContext);
  const { formState, onDispatchForm } = props;
  
  const submitFormHandler = async (event) => {
    event.preventDefault();
    const values = {
      lastName: formState.lastNameValue,
      firstName: formState.firstNameValue,
      emailAddress: formState.emailValue,
      password: formState.passwordValue,
      confirmPassword:
        formState.confirmPasswordValue,
    };
    if (values.emailAddress) {
      authCtx.onSaveEmailExist(
        false,
        values.emailAddress
      );
    }
    // console.log(formState.emailIsValid);

    onDispatchForm({
      type: "FORM_SUBMIT",
      values,
    });
    const {
      lastNameIsValid,
      firstNameIsValid,
      emailIsValid,
      passwordIsValid,
    } = formState;
    if (
      lastNameIsValid &&
      firstNameIsValid &&
      emailIsValid &&
      passwordIsValid
    ) {
      const data = {
        lastName: values.lastName,
        firstName: values.firstName,
        emailAddress: values.emailAddress,
        password: values.password,
      };
      await RegisterUser(authCtx, data);
    }
  };
  return (
    <form
      className={styles.form}
      onSubmit={submitFormHandler}
    >
      <SignUpForm1 {...props} />
      <SignUpForm2 {...props} />
      <SignUpForm3 {...props} />
      <SignUpFormAction1 {...props} />
    </form>
  );
};

export default SignUpFormGroup;
